// extracted by mini-css-extract-plugin
module.exports = {"list":"GroupList__list","listItem":"GroupList__listItem","nameList":"GroupList__nameList","listKey":"GroupList__listKey","listValue":"GroupList__listValue"};